export const inbox = () => (
  <path
    d="M22 12h-6l-2 3h-4l-2-3H2m20 0v6a2 2 0 01-2 2H4a2 2 0 01-2-2v-6m20 0l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11L2 12"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
